import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, ArrowRight, XCircle, CheckCircle2 } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-24 bg-[#0a0a1a] relative overflow-hidden border-y border-white/5" data-id="element-316">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-red-900/10 rounded-full blur-[120px]" data-id="element-317" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-318">
        <div className="text-center mb-16" data-id="element-319">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-500/10 border border-red-500/20 text-red-400 text-sm font-medium mb-6" data-id="element-320">
            <AlertCircle className="w-4 h-4" data-id="element-321" />
            El problema de la mayoría de negocios
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-5xl font-bold font-orbitron mb-6" data-id="element-322">
            Muchos negocios publican en Instagram...{' '}
            <br className="hidden md:block" data-id="element-323" />
            <span className="text-red-400" data-id="element-324">
              pero pierden clientes todos los días.
            </span>
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center max-w-5xl mx-auto" data-id="element-325">
          {/* The Problem */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#050510] border border-red-500/20 rounded-3xl p-8 relative overflow-hidden" data-id="element-326">
            <div className="absolute top-0 left-0 w-2 h-full bg-red-500/50" data-id="element-327" />
            <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-328">
              <XCircle className="w-6 h-6 text-red-400" data-id="element-329" />
              Lo que pasa actualmente:
            </h3>
            <ul className="space-y-4" data-id="element-330">
              <li className="flex items-start gap-3 text-gray-400" data-id="element-331">
                <span className="text-red-400 mt-1" data-id="element-332">•</span>
                <span data-id="element-333">
                  Los clientes ven tu contenido en redes, pero no saben cómo
                  contactarte o contratar tus servicios.
                </span>
              </li>
              <li className="flex items-start gap-3 text-gray-400" data-id="element-334">
                <span className="text-red-400 mt-1" data-id="element-335">•</span>
                <span data-id="element-336">
                  Te escriben preguntando "¿cuánto cuesta?" y luego desaparecen
                  porque no ven el valor completo de lo que ofrecés.
                </span>
              </li>
              <li className="flex items-start gap-3 text-gray-400" data-id="element-337">
                <span className="text-red-400 mt-1" data-id="element-338">•</span>
                <span data-id="element-339">
                  Invertís en publicidad, conseguís seguidores, pero tu agenda
                  sigue con huecos.
                </span>
              </li>
            </ul>
          </motion.div>

          {/* The Solution */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-gradient-to-br from-purple-900/20 to-pink-900/20 border border-purple-500/30 rounded-3xl p-8 relative overflow-hidden" data-id="element-340">
            <div className="absolute top-0 left-0 w-2 h-full bg-gradient-to-b from-purple-500 to-pink-500" data-id="element-341" />
            <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-342">
              <CheckCircle2 className="w-6 h-6 text-green-400" data-id="element-343" />
              Lo que logras con nosotros:
            </h3>
            <ul className="space-y-4" data-id="element-344">
              <li className="flex items-start gap-3 text-gray-300" data-id="element-345">
                <span className="text-green-400 mt-1" data-id="element-346">✓</span>
                <span data-id="element-347">
                  Una página web profesional que muestra tus servicios y genera
                  contactos al instante.
                </span>
              </li>
              <li className="flex items-start gap-3 text-gray-300" data-id="element-348">
                <span className="text-green-400 mt-1" data-id="element-349">✓</span>
                <span data-id="element-350">
                  Solo te escriben clientes informados y listos para contratar.
                </span>
              </li>
              <li className="flex items-start gap-3 text-gray-300" data-id="element-351">
                <span className="text-green-400 mt-1" data-id="element-352">✓</span>
                <span data-id="element-353">
                  Botón directo a tu WhatsApp para que te contacten sin
                  complicaciones.
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}